// eslint-disable-next-line camelcase
import jwt_decode from "jwt-decode";

interface DecodedJWT {
  sub: string;
  email: string;
  auth_time: number;
  exp: number;
  iat: number;
  name?: string;
  family_name?: string;
  given_name?: string;
  "custom:role"?: string;
  "cognito:username"?: string;
  email_verified?: boolean;
  at_hash?: string;
  aud: string;
  token_use: string;
  iss: string;
}

const getCookie = (name: string): string => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts && parts.length === 2) {
    // @ts-ignore
    return parts
      .pop()
      .split(";")
      .shift();
  }
  return "";
};

export const setIdToken = (token: string) => {
  document.cookie = `id_token=${token}; domain=${process.env.REACT_APP_CUSTOM_SUBDOMAIN_NAME}; secure`;
};

export const setRefreshToken = (token: string) => {
  document.cookie = `refresh_token=${token}; domain=${process.env.REACT_APP_CUSTOM_SUBDOMAIN_NAME}; secure`;
};

export const getIdToken = (): string => {
  return getCookie("id_token");
};

export const getRefreshToken = (): string => {
  return getCookie("refresh_token");
};

export const getChannel = (): string => {
  return getCookie("channel");
};

const getOwnerMerchantFromCookie = (): string => {
  const token = getIdToken();
  try {
    const decodedJWT: DecodedJWT = jwt_decode(token);
    return `${decodedJWT.given_name}`;
  } catch (err) {
    return "";
  }
};

export const getOwnerUserName = (): string => {
  const token = getIdToken();
  try {
    const decodedJWT: DecodedJWT = jwt_decode(token);
    return `${decodedJWT["cognito:username"]}`;
  } catch (err) {
    return "";
  }
};

export const getEmail = (): string => {
  const token = getIdToken();
  try {
    const decodedJWT: DecodedJWT = jwt_decode(token);
    return decodedJWT.email;
  } catch (err) {
    return "";
  }
};

export const getOwnerCookieExpiry = (): number | undefined => {
  const token = getIdToken();
  try {
    const decodedJWT: DecodedJWT = jwt_decode(token);
    return decodedJWT.exp;
  } catch (err) {
    return undefined;
  }
};

export default getOwnerMerchantFromCookie;
